import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors, } from '@angular/common/http';
import { NgbDatepickerConfig, NgbInputDatepickerConfig, NgbPopoverConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ColorPickerModule } from 'ngx-color-picker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QuillModule } from 'ngx-quill';
import { CurrencyPipe } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';

// Services
import { NotificationService } from './notification.service';
import { PendingChangesGuard } from './pending-changes.guard';
import { MockupPendingChangesGuard } from './features/mockup/mockup-pending-changes.guard';
import { ConversationService } from './conversation.service';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { ApiRequestInterceptor } from './api-request.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';

export function initializeApp(ns: NotificationService) {
    return () => ns.load();
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAppInitializer(() => {
            const initializerFn = (initializeApp)(inject(NotificationService));
            return initializerFn();
        }),
        provideHttpClient(
            withInterceptors([
                ApiRequestInterceptor,
            ])
        ),
        NgbDatepickerConfig,
        NgbInputDatepickerConfig,
        NgbPopoverConfig,
        NgbTooltipConfig,
        CurrencyPipe,
        PendingChangesGuard,
        MockupPendingChangesGuard,
        ConversationService,
        importProvidersFrom(
            DragDropModule,
            NgxSpinnerModule,
            ColorPickerModule,
            CalendarModule.forRoot({
                provide: DateAdapter,
                useFactory: adapterFactory,
            }),
            QuillModule.forRoot({
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ header: 1 }, { header: 2 }],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ script: 'sub' }, { script: 'super' }],
                        [{ indent: '-1' }, { indent: '+1' }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ font: [] }],
                        [{ align: [] }],
                        ['clean', 'link'],
                    ],
                },
            })
        ),
        provideAnimations(),
    ]
};

export function configureDatepicker(
    datepickerConfig: NgbDatepickerConfig,
    inputDatepickerConfig: NgbInputDatepickerConfig,
    popoverConfig: NgbPopoverConfig,
    tooltipConfig: NgbTooltipConfig
) {
    datepickerConfig.firstDayOfWeek = 7;
    inputDatepickerConfig.container = 'body';
    popoverConfig.container = 'body';
    tooltipConfig.container = 'body';
}
